var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h1Title"},[_c('p',{staticClass:"h2-tit1"},[_vm._v(_vm._s(_vm.title1))]),_vm._v(" "),_c('p',{staticClass:"h2-tit2"},[_c('span',{staticClass:"cont"},[_vm._v(_vm._s(_vm.title2))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36ac1490","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/h2Title.vue
// module id = null
// module chunks = 